import { Box, styled } from '@mui/material';

import { EResourceType, HubsViewMode, ResourceRegionType } from '#shared';

import { DrawerViewType } from '../../ResourceDrawer';
import { BaseCard, classes } from '../BaseCard';
import { StaffWithCounts } from '../components';
import { aggregateResourcesCounts } from '../utils';

import type { StaffInfo } from '#entities';

type Props = {
  surgeons: StaffInfo[];
  region: ResourceRegionType;
  label?: string;
  onClick?: (id: string, type: DrawerViewType) => void;
  hubsViewMode?: HubsViewMode;
  isEastOverride?: boolean;
};

const SurgeonContent = styled(Box)({
  height: '100%',
});

export const SurgeonGroupCard = ({
  surgeons,
  region,
  label,
  onClick,
  hubsViewMode,
  isEastOverride,
}: Props) => {
  const isEast =
    typeof isEastOverride === 'boolean'
      ? isEastOverride
      : region === ResourceRegionType.East &&
        hubsViewMode !== HubsViewMode.Flat;

  const handleSurgeonClick = () => onClick?.(region, DrawerViewType.Surgeon);
  return (
    <BaseCard
      isEast={isEast}
      isFlat={hubsViewMode === HubsViewMode.Flat}
      onClick={handleSurgeonClick}
    >
      <SurgeonContent className={classes.verticalColumn}>
        <Box className={classes.resourcesBox}>
          <StaffWithCounts
            staffInfo={{
              id: `${region}-surgeon`,
              teamMemberType: EResourceType.Surgeon,
              countsInfo: aggregateResourcesCounts(surgeons),
              details: [],
            }}
            isEast={isEast}
          />
        </Box>
        <Box className={classes.abbreviation}>{label}</Box>
      </SurgeonContent>
    </BaseCard>
  );
};
